import React, { useContext, useState } from 'react';
import HeaderMobile from 'src/components/layout/redesign/header-mobile';
import { amplitudeTrackEvent } from 'src/helpers/amplitude-event-track';
import { useDocumentDesktopOnlyScroll } from 'src/components/layout/redesign/header-shared/use-document-desktop-only-scroll';
import { CareerCmsContent } from 'src/content/career-content';

const CareerHeaderMobile = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const setDocumentDesktopOnlyScroll = useDocumentDesktopOnlyScroll();

  const { careerHeaderContent } = useContext(CareerCmsContent);

  return (
    <HeaderMobile
      headerContent={careerHeaderContent.careerHeader}
      primaryButton={
        careerHeaderContent?.careerHeader.headerButtonPrimary
          ? {
              type: 'link',
              buttonProps: careerHeaderContent.careerHeader.headerButtonPrimary,
              handleClick: () => {
                setIsMobileMenuOpen(false);
                amplitudeTrackEvent('Click to Primary Button', {
                  custom_page: window.location.origin,
                });
              },
            }
          : undefined
      }
      secondaryButton={
        careerHeaderContent?.careerHeader.headerButtonSecondary && {
          type: 'link',
          buttonProps: careerHeaderContent.careerHeader.headerButtonSecondary,
          handleClick: () => {
            amplitudeTrackEvent('Click to "Secondary Button" - Navigation', {
              custom_page: window.location.origin,
            });
          },
        }
      }
      isMenuOpen={isMobileMenuOpen}
      setMenuOpen={(isOpen) => {
        setIsMobileMenuOpen(isOpen);
        setDocumentDesktopOnlyScroll(isOpen);
      }}
    />
  );
};

export default CareerHeaderMobile;
